import { useTranslation } from "react-i18next";

export type ErrorKey = (typeof ERROR_KEYS)[number];

interface ErrorMessageProps {
  error: ErrorKey;
}

export const REQUIRED_ERROR_KEY = "required";
export const PATTERN_ERROR_KEY = "pattern";
export const INVALID_FILE_TYPE_ERROR_KEY = "invalidFileType";
export const ERROR_KEYS = [
  REQUIRED_ERROR_KEY,
  PATTERN_ERROR_KEY,
  INVALID_FILE_TYPE_ERROR_KEY,
] as const;
const ERRORS = {
  required: "Vacancies.form.error.required",
  pattern: "Vacancies.form.error.pattern",
  invalidFileType: "Vacancies.form.error.invalidFileType",
} satisfies Record<ErrorKey, string>;

export const ErrorMessage = ({ error }: ErrorMessageProps) => {
  const { t } = useTranslation();

  return (
    <p className="text-sm text-red-600" role="alert">
      {t(ERRORS[error])}
    </p>
  );
};
